import HomeworkList from './homework/homeworkList';
import HomeworkDetail from './homework/homeworkDetail/homeworkDetail';
import HomeworkInfo from './homework/homeworkInfo/homeworkInfo';
import HomeworkRecordList from './homeworkrecord/homeworkRecordList';
import HomeworkRecordShow from "./homeworkrecord/homeworkrecordinfo/homeworkrecordshow";
import HomeworkRecordAudit from "./homeworkrecord/homeworkrecordinfo/homeworkrecordAudit";
import HomeworkRecordReviewList from './homeworkrecord/homeworkRecordReviewList'


export {
  HomeworkList,
  HomeworkDetail,
  HomeworkInfo,
  HomeworkRecordList,
  HomeworkRecordShow,
  HomeworkRecordAudit,
  HomeworkRecordReviewList
}


